import { useState } from 'react';
import { CrudFilters, MetaQuery, useDataProvider } from '@refinedev/core';
import { SkuQtyRow } from '@admin-panel/types';
import { generateProductLabelFileWithNewMrp } from './label_pdf_generator_new_mrp';
import { useGlobalContext } from '../global';

export type LabelExportOptionsNewMrp = {
  resource: string;
  exportFileName: string;
  getSkuQuantityEntry: (entity: any) => SkuQtyRow;
  onError?: (error: any) => void;
  filters?: CrudFilters;
  meta?: MetaQuery;
};

export type UseLabelExportReturnTypeNewMrp = {
  isLoading: boolean;
  triggerExport: () => Promise<string | undefined>;
};

export const useBarcodeExportWithQuantityNewMrp = (props: LabelExportOptionsNewMrp) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const dataProvider = useDataProvider();
  const defaultDataProvider = dataProvider();
  const { organization } = useGlobalContext();

  const fetchPage = async () => {
    const { data } = await defaultDataProvider.getList<any>({
      resource: props.resource,
      filters: props.filters,
      meta: props.meta,
      pagination: {
        currentPage,
        pageSize: 1000,
        mode: 'server',
      },
    });
    if (data && data.length > 0) {
      return data.map((row: any) => props.getSkuQuantityEntry(row));
    }
    return [];
  };

  const triggerExport = async () => {
    setIsLoading(true);

    const allRecords: SkuQtyRow[] = [];
    let preparingData = true;
    while (preparingData) {
      try {
        const records: SkuQtyRow[] = await fetchPage();

        setCurrentPage(currentPage + 1);
        if (records.length < 1000) preparingData = false;

        allRecords.push(...records);
      } catch (error) {
        setIsLoading(false);
        preparingData = false;
        props.onError?.(error);

        return;
      }
    }
    setCurrentPage(1);

    const doc = generateProductLabelFileWithNewMrp(allRecords, organization);

    //doc?.save(props.exportFileName);
    const base64string = doc?.output('bloburl');
    debugBase64(base64string);

    setIsLoading(false);
  };

  return {
    isLoading,
    triggerExport,
  };
};

function debugBase64(base64URL: any) {
  const win = window.open();
  win?.document.write(
    '<iframe src="' +
      base64URL +
      '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>',
  );
}
